import { IconWarningBadgedSmallFilled } from '@teamleader/ahoy';
import { translate } from '@teamleader/i18n';
import React from 'react';

import InvoicesHeaderAmount from './InvoicesHeaderAmount';
import Box from '../../../../Components/UI/Box';
import { Department } from '../../../../Types/department';
import { Invoice, MATCHED_STATUS } from '../../../../Types/invoice';
import { apiFormatDate, formatDueDate, fromISO } from '../../../../Utils/date';
import styles from '../styles.css';

interface InvoicesHeaderData {
  invoice: Invoice;
  department: Department;
}

const InvoicesHeaderData: React.FC<InvoicesHeaderData> = ({ invoice, department }) => {
  const { label, date, isOverDue } = formatDueDate(fromISO(invoice.dueDate), department.dateFormat);

  return (
    <>
      <InvoicesHeaderAmount invoice={invoice} />
      {invoice.matchedStatus === MATCHED_STATUS.UNMATCHED && (
        <Box className={styles['data']} marginLeft={5}>
          <h4 className={styles['data-label']}>{label}</h4>
          <span className={styles['data-value']}>
            {date} {isOverDue && <IconWarningBadgedSmallFilled className={styles['icon']} />}
          </span>
        </Box>
      )}
      {invoice.paidAt && (
        <Box className={styles['data']} marginLeft={5}>
          <h4 className={styles['data-label']}>
            {translate(invoice.matchedStatus === MATCHED_STATUS.FULLY_CREDITED ? 'creditedOn' : 'paidOn')}
          </h4>
          <span className={styles['data-value']}>{apiFormatDate(fromISO(invoice.paidAt), department.dateFormat)}</span>
        </Box>
      )}
    </>
  );
};

export default InvoicesHeaderData;
